import ProposalBase from '../ProposalBase'
import { policyChangedChecker } from '@/mixin'
import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('ins')
const {
  mapGetters: commonMapGetters
} = createNamespacedHelpers('common')

export default {

  extends: ProposalBase,

  mixins: [policyChangedChecker],

  props: {
    tabListProp: Array,
    tabStepProp: String,
    polInsureType: String, // 案件類型
    propKey: {
      transCode: String,
      cusTypeOCheck: { type: String, default: 'N' }, // 要保人發查記錄
      cusTypeICheck: { type: String, default: 'N' }, // 被保人發查記錄
      policyLegAgent: { type: String, default: 'N' }, // 要保人法代發查資料
      insuredLegAgent: { type: String, default: 'N' }, // 被保人法代發查資料
      cusTypeORefAddressR: { type: String, default: '' }, // 要保人參考的戶籍地址
      cusTypeORefAddress: { type: String, default: '' }, // 要保人參考的住所地址
      cusTypeIRefAddressR: { type: String, default: '' }, // 被保人參考的戶籍地址
      cusTypeIRefAddress: { type: String, default: '' },  // 被保人參考的住所地址
      cusTypeOAddressRCheck: { type: String, default: 'N' }, // 要保人的戶籍地址已發查
      cusTypeOAddressCheck: { type: String, default: 'N' }, // 要保人的住所地址已發查
      cusTypeIAddressRCheck: { type: String, default: 'N' }, // 被保人的戶籍地址已發查
      cusTypeIAddressCheck: { type: String, default: 'N' }, // 被保人的住所地址已發查
    },
    isPreview: {
      // 是否為檢視模式
      type: Boolean,
      default: false
    },
    pChangeYn: {
      // 資料是否異動
      type: String,
      default: 'N'
    },
    pSignedYn: {
      // 簽名是否存在
      type: String,
      default: 'N'
    }
  },

  data () {
    return { // 要保書流程全域變數
      transCode: '', // 行動投保序號
      compCode: '',
      cusTypeOCheck: 'N', // 要保人發查記錄
      cusTypeICheck: 'N', // 被保人發查記錄
      policyLegAgent: 'N', // 要保人法代發查資料
      insuredLegAgent: 'N', // 被保人法代發查資料
      cusTypeORefAddressR: '', // 要保人參考的戶籍地址
      cusTypeORefAddress: '', // 要保人參考的住所地址
      cusTypeIRefAddressR: '', // 被保人參考的戶籍地址
      cusTypeIRefAddress: '', // 被保人參考的住所地址
      cusTypeOAddressRCheck: 'N', // 要保人的戶籍地址已發查
      cusTypeOAddressCheck: 'N', // 要保人的住所地址已發查
      cusTypeIAddressRCheck: 'N', // 被保人的戶籍地址已發查
      cusTypeIAddressCheck: 'N', // 被保人的住所地址已發查
      checkItemObject: {} // 檢核項目資料(呼叫服務成功才傳物件)
    }
  },

  computed: {
    ...commonMapGetters([
      'cityList',
      'areaMap',
      'zipMap',
      'countryList',
      'jobsList',
      'allAdmCodeDetail',
      'allBranchs',
      'allPostalCode',
      'systemParam',
      'admCodeDetail'
    ]),
    insParameters () {
      return this.$store.getters['common/systemParam']({
        parameterType: 'INS',
        toObject: true
      })
    },
    relationList () {
      return this.$store.getters['common/admCodeDetail']({
        codeType: 'RELATION_OWNER_CODE',
        codeValue: ['1', '2', '3', '4', '5', '6']
      })
    }
  },
  beforeRouteEnter (to, from, next) {
      next()
  },
  created () {

  },
  watch: {
    propKey: {
      immediate: true,
      deep: true,
      handler (val) {
        if (val) {
          if (val.transCode) {
            this.transCode = val.transCode
          }
          this.compCode = val.compCode
          this.cusTypeOCheck = val.cusTypeOCheck || 'N'
          this.cusTypeICheck = val.cusTypeICheck || 'N'
          this.policyLegAgent = val.policyLegAgent || 'N'
          this.insuredLegAgent = val.insuredLegAgent || 'N'

          this.cusTypeORefAddressR = val.cusTypeORefAddressR || ''
          this.cusTypeORefAddress = val.cusTypeORefAddress || ''
          this.cusTypeIRefAddressR = val.cusTypeORefAddress || ''
          this.cusTypeIRefAddress = val.cusTypeORefAddress || ''

          this.cusTypeOAddressRCheck = val.cusTypeOAddressRCheck || 'N'
          this.cusTypeOAddressCheck = val.cusTypeOAddressCheck || 'N'
          this.cusTypeIAddressRCheck = val.cusTypeIAddressRCheck || 'N'
          this.cusTypeIAddressCheck = val.cusTypeIAddressCheck || 'N'
        }

      }
    },
    tabListProp: {
      immediate: true,
      deep: true,
      handler (val) {
        if (val && val.length > 0) {
          this.tabList = [...val]
        }
      }
    },
    tabStepProp: {
      immediate: true,
      handler (val) {
        if (val) {
          this.tabStep = val
        }

      }
    }
  },

  methods: {
    ...mapActions([
      'delInsRec',
      'fetchCheckItem',
    ]),
    $tempStatus (isTemp) {
      return isTemp ? 'T' : 'S'
    },
    $setTabShow(step, flag) {
      let item = this.tabList.find(obj => {
        return obj.step === step
      })
      if (item) {
        item.show = flag
        this.$emit('set-tab-show', {step, flag})
      }
    },
    $setTabDone(step, flag) {
      let item = this.tabList.find(obj => {
        return obj.step === step
      })
      if (item) {
        item.done = flag
        this.$emit('set-tab-done', {step, flag})
      }
    },
    /**
     *
     * @param {number} step 特定step
     */
    $preStepHandler (step) {
      this.$emit('go-top')
      let name = ''
      let tabStep = ''
      if (step) {
        let item = this.tabList.find(obj => {
          return (obj.step === step && obj.show)
        })
        if (item) {
          name = item.rt
        }
      }
      if (!name) {
        let toStep = ''
        let item = this.tabList.find(obj => {
          return obj.step === this.tabStep
        })
        if (item) {
          toStep = item.preStep
        }
        while (toStep) {
          item = this.tabList.find(obj => {
            return obj.step === toStep
          })
          if (item && item.show) {
            name = item.rt
            tabStep = item.step
            break
          } else if (item) {
            toStep = item.preStep
          } else {
            toStep = ''
          }
        }
      }
      if (!name) return
      this.$emit('temp-btn-hide',tabStep, this.isPreview)
      if(tabStep === 'n4') { // 進入檢核項目頁面(呼叫電文)
        this.fetchCheckItem({ transCode: this.transCode, isPreview: this.isPreview }).then(r => {
          if (r.data.errorMsg != null ) { // 不通過要顯示訊息
            this.tabItemActive = this.tabStep // tab亮燈停留在當下頁面
            this.$alert(r.data.errorMsg )
          } else {
            this.routerReplace(name,tabStep,r.data ,false) // 帶prop 參數與電文檢核後的資料做rouer導頁
          }
        })
      } else {
        this.routerReplace(name,tabStep,null ,false) // 帶prop 參數做rouer導頁
      }
    },
    /**
     *
     * @param {number} step 特定step
     */
    $nextStepHandler (step) {
      this.$emit('go-top')
      let name = ''
      let tabStep = ''
      if (step) {
        let item = this.tabList.find(obj => {
          return (obj.step === step && obj.show)
        })
        if (item) {
          name = item.rt
        }
      }
      if (!name) {
        let toStep = ''
        let item = this.tabList.find(obj => {
          return obj.step === this.tabStep
        })
        if (item) {
          toStep = item.nextStep
        }
        while (toStep) {
          item = this.tabList.find(obj => {
            return obj.step === toStep
          })
          if (item && item.show) {
            name = item.rt
            tabStep = item.step
            break
          } else if (item) {
            toStep = item.nextStep
          } else {
            toStep = ''
          }
        }
      }
      if (!name) return
      this.$emit('temp-btn-hide',tabStep, this.isPreview)
      if(tabStep === 'n4') { // 進入檢核項目頁面(呼叫電文)
        this.fetchCheckItem({ transCode: this.transCode, isPreview: this.isPreview }).then(r => {
          if (r.data.errorMsg != null ) {// 不通過要顯示訊息
            this.tabItemActive = this.tabStep // tab亮燈停留在當下頁面
            this.$alert(r.data.errorMsg )
          } else {
            this.routerReplace(name,tabStep, r.data ,true) // 帶prop 參數與電文檢核後的資料做router導頁
          }
        })
      } else {
        this.routerReplace(name,tabStep,null ,true) // 帶prop 參數做router導頁
      }
    },
    routerReplace(name,tabStep, checkItemObject ,transCodeStauts ) {
      const params = {
        ...this.$props,
        tabStepProp: tabStep,
        propKey: {
          transCode: this.transCode,
          compCode: this.compCode,
          cusTypeOCheck: this.cusTypeOCheck,
          cusTypeICheck: this.cusTypeICheck,
          policyLegAgent: this.policyLegAgent,
          insuredLegAgent: this.insuredLegAgent,
          cusTypeORefAddressR: this.cusTypeORefAddressR,
          cusTypeORefAddress: this.cusTypeORefAddress,
          cusTypeIRefAddressR: this.cusTypeORefAddress,
          cusTypeIRefAddress: this.cusTypeORefAddress,
          cusTypeOAddressRCheck: this.cusTypeOAddressRCheck,
          cusTypeOAddressCheck: this.cusTypeOAddressCheck,
          cusTypeIAddressRCheck: this.cusTypeIAddressRCheck,
          cusTypeIAddressCheck: this.cusTypeIAddressCheck,
          checkItemObject: checkItemObject,
        }
      }
      this.tabItemActive = tabStep // 要前往的tab亮燈
      if ( transCodeStauts && this.transCode !== this.propKey.transCode) {
        // 新增的狀況
        params.propKey.transCode = this.transCode
      }

      let vm = this
      vm.$nextTick(() => {
        setTimeout(() => {
          vm.$router.replace({ name, params })
        }, 0)
      })
    },
    hasSpecialChar (val) {
      const regex = /[\uE000-\uF8FF\u02BC\u2303\u1E5F\u00E9\u0268\u0289]/
        if (regex.test(val)) {
          return true
        }
        return false
    },
    hasBlankChar (val) {
      if (/\s/.test(val)) {
        return true
      }
      return false
    }
  }

}
